export default "__VITE_ASSET__CcMGetu9__"